import { TOGGLE_SETTINGS_POPUP } from '../../constants';

export const toggleSettingsPopup = (status) => ({ type: TOGGLE_SETTINGS_POPUP, status });
